<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="DED"><span epub:type="pagebreak" id="pg_v" title="v"><span class="ePub-I">For Jonas, August, Isabeau, and Freya, may you be alert to danger in its many guises.</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3dbd4f18